<template>
    <div class="login-container">
        <el-card class="login-box">
            <template #header>
                <div class="card-header" style="width: 100%; text-align: center; font-size: 30px">
                    <span>登录</span>
                </div>
            </template>
            <el-form :model="form" class="login-form">
                <el-form-item>
                    <el-input v-model="form.mobile" placeholder="手机号" ref="mobile"></el-input>
                </el-form-item>
                <el-form-item class="verify-code">
                    <el-input v-model="form.scode" placeholder="验证码" ref="scode">
                        <template #append>
                            <el-button @click="handleSend">{{ sendSmsBtn }}</el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <div style="width: 100%; text-align: center">
                        <el-button type="primary" @click="handleLogin" style="width: 100%">登录</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import { setCookie } from '@/utils/cookie';
import * as api from '@/api';
import { ElMessage } from 'element-plus';
export default {
    data() {
        return {
            to: '',

            form: {
                mobile: '',
                scode: '',
            },

            step: 0, // 0初始化、1已发送、2发送完
            sendSmsBtn: '发送',
            ticker: null,
            tickerCnt: 59,
        };
    },

    watch: {
        step(val) {
            var self = this;
            if (val == 1) {
                self.sendSmsBtn = self.tickerCnt + 's';
                clearInterval(this.ticker);
                this.ticker = setInterval(this.addTickerCnt, 1000);
            } else if (val == 2) {
                this.sendSmsBtn = '发送';
            }
        },
    },

    mounted() {
        if (this.$route.userInfo) {
            this.to = this.$route.query.to || '';
            this.jumpTo();
            return;
        }

        setTimeout(() => {
            this.focusMobile();
        }, 0);
    },

    beforeUnmount() {
        clearInterval(this.ticker);
    },

    methods: {
        addTickerCnt() {
            this.tickerCnt--;
            if (this.tickerCnt <= 0) {
                clearInterval(this.ticker);
                this.tickerCnt = 59;
                this.step = 2;
            } else {
                this.sendSmsBtn = this.tickerCnt + 's';
            }
        },

        focusMobile() {
            this.$refs.mobile.focus({ preventScroll: true });
        },

        focusScode() {
            this.$refs.scode.focus({ preventScroll: true });
        },

        handleSend() {
            if (!/^[1][3|4|5|6|7|8|9][0-9]{9}$/.test(this.form.mobile)) {
                this.focusMobile();
                return;
            }
            if (this.step == 1) {
                return;
            }
            this.step = 1;
            this.focusScode();
            api.sendcode(this.form.mobile)
                .then(res => {})
                .catch(res => {
                    ElMessage.error(res.message);
                });
        },

        handleLogin() {
            if (this.step == 0) {
                return;
            }
            if (this.form.scode.length == 0) {
                this.focusScode();
                return;
            }
            api.login(this.form.mobile, this.form.scode)
                .then(res => {
                    const data = res.data;
                    setCookie(data);
                    this.jumpTo();
                })
                .catch(res => {
                    ElMessage.error(res.message);
                });
        },

        jumpTo() {
            this.$router.replace(this.to || '/');
        },
    },
};
</script>

<style scoped>
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.login-box {
    width: 300px;
}

.verify-code .el-input-group__append {
    margin-left: -1px;
}
</style>
